/**
 * Route for `igaming-cpa`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingCpaPage } from "../features/igaming-cpa/IgamingCpaPage";

export const igamingCpaRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-cpa",
	component: IgamingCpaPage,
});

export default igamingCpaRoute;
